import * as d3 from 'd3'

type YDomain = { yMin: number; yMax: number }

export const setYDomain = (
  minY: number | null,
  maxY: number | null,
  scale: d3.ScaleContinuousNumeric<number, number>,
  axis: d3.Selection<SVGGElement, unknown, null, undefined>,
  fnGetDomain: () => YDomain,
  fnRender: () => void
) => {
  const domain = fnGetDomain()

  scale.domain([minY ?? domain.yMin, maxY ?? domain.yMax]).nice()

  axis.call(d3.axisLeft(scale))

  fnRender()
}
